import styled from '@emotion/styled'

import { breakpoints, spacing } from 'main/ui'

export const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`

export const ContentContainer = styled.div`
  align-items: center;
  text-align: center;
  margin-top: ${spacing.majorScale(2)}px;
  max-width: 550px;
`

export const ImageContainer = styled.div`
  margin: ${spacing.majorScale(2)}px 0;
  width: 100%;
`

export const TitleContainer = styled.div`
  margin: 0 ${spacing.majorScale(4)}px ${spacing.majorScale(3)}px;

  > * {
    width: 100%;
  }

  @media (min-width: ${breakpoints.lg}px) {
    margin: 0;
  }
`
